import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'
import { YesNoBadge } from '../../../components/YesNoBadge'
import { renderAllRelations } from '../Components'

export const getColumnsConfig = (): TableColumn<ProductOrigin>[] => [
  { key: 'origin', title: 'Origen' },
  { key: 'name', title: 'Marca' },
  {
    key: 'orderOriginNames',
    title: 'Canales de Venta',
    width: 300,
    render: (value) =>
      renderAllRelations((value as string[] | undefined) || [], 'center')
  },
  { key: 'typeStorageName', title: 'Tipo de Almacenamiento' },
  {
    key: 'isActive',
    title: 'Activo',
    render: (value) => <YesNoBadge value={value as boolean} />
  },
  {
    key: 'expirationDays',
    title: 'Tolerancia en días de Picking FEFO',
    render: (value) => (value === null || value === undefined ? 'Sin Configurar' : (value as number))
  }
]
